
/** 规格配备类型 */
export enum EValueType {
  /** 文本 */
  TEXT = "text",
  /** 多個文本 */
  REPEATEDVALUE = "repeatedValue",
  /** 套件 */
  OPTIONALKIT = "optionalKit",
  /** 颜色 */
  COLOR = "color",
  /** 安全氣囊配備 */
  AIRBAG = "airBag",
  /** 安全配備 */
  SAFEEQUIP = "safeEquip",
  /** 多媒體配備 */
  MULTIMEDIA = "multimedia",
  /** 長寬高/軸距 */
  SIZE = "size",
  /** 座椅功能 */
  MULTITAG = "multiTag",
  /** 每公里能耗成本預估 */
  TEXTWITHTIP = "textWithTip",
  /** 文本是否有小数点 */
  COSTTEXT = "costText",
}

/** 规格配备类型 */
export enum EItemsDiffType {
  /** 高亮不同項 */
  HIGHLIGHT_DIFF = "HighlightDiff",
  /** 隱藏相同項 */
  HIDE_IDENTICAL = "HideIdentical",
  /** 隱藏暫無項 */
  HIDE_NONE = "HideNone",
}

/** 页面类型 */
export enum EPageType {
  /** 综合比较 */
  SUMMARY = "Summary",
  /** 规格配备比较 */
  SPEC = "Spec",

}


/** 左邊列表 */
export interface ILeftList {
  id: number;
  name: string;
}
export interface ISearchModel {
  entryId: number;
  name: string;
}

export interface IDataItem {
  emptyDefault: number;
  /**
   * 规格配备
   */
  equipSpec: IEquipSpec[];
  modelYearInfo: IModelYearInfo;
}

export interface IEquipSpec {
  id: number;
  // items: IEquipSpecItem[];
  items: any[];
  /**
   * 大类的名字
   */
  name: string;
  sort: number;
  /**
   * 规格配备类型，1为规格， 2为配备
   */
  type: string;
}

export interface IEquipSpecItem {
  entryId: number;
  id: number;
  /**
   * 重点项 true为重点
   */
  important: boolean;
  /**
   * 介绍id，id大于0则有
   */
  introId: string;
  /**
   * 小类名称
   */
  name: string;
  sort: number;
  /**
   * text 为文本展示 inquiry 为一键询价，text 为文本
   * repeatedString 为字符串数组
   *
   * optionalKit 为外观套件 [{"title": "套件名稱", "description": "套件子名稱", "price":"$2000"}, {"title":
   * "套件名稱dddd", "description": "套件子名稱bbbbbb", ', "price":"$2000"}]
   *
   * color 为颜色 [{"color":"#000000", "name": "黑色", "price": "$2000"}, {"color":"#FFFFFF",
   * "name": "白色", "price": "$3000"}, {"color":"#FF0000", "name": "紅色", "price": ""}]
   *
   * priceAndInquiry 价格下询价
   */
  type: string;
  /**
   * 单位
   */
  unit: string;
  /**
   * 内容
   */
  value: string;
  [key: string]: any;
}

export interface IModelYearInfo {
  driveType: string;
  power: string;
  gas: string;
  saleStop: number;
  brandId: number;
  brandName: string;
  isInquiry: number;
  kindId: number;
  kindName: string;
  modelName: string;
  modelYearId: number;
  price: number | string;
  year: number;
  isPinned: boolean;
  name: string;
  isAds: boolean;
  adsLink: string;
  [key: string]: any;
}


export interface IBrand {
  index: string[];
  brand: {
    label: string;
    list: IBrandList[];
  }[];
}

export interface IBrandList {
  activity?: string;
  children?: {
    /**
  * 车款ID
  */
    id?: number;
    /**
     * 车款名
     */
    name?: string;
  }[];
  /**
   * 厂牌英文名
   */
  enName?: string;
  /**
   * 是否有停售：1是，0否
   */
  hasSaleStop: number;
  /**
   * 厂牌ID
   */
  id?: number;
  /**
   * 厂牌图片
   */
  image?: string;
  /**
   * 厂牌字母标签
   */
  label?: string;
  /**
   * 厂牌名称
   */
  name?: string;
  /**
   * 在售车款数
   */
  onSaleKindNum: number;
  /**
   * 路由名
   */
  urlName: string;
  /**
   * 厂牌中文名
   */
  zhName?: string;
}


export interface IModel {
  batteryLife: string;
  minimumPrice: string;
  power: string;
  year: number;
  myid: number;
  modelYearId: number;
  modelName: string;
  tab: string;
  price: string;
  gas: string;
  poweer: string;
  thumb: string;
  newKindId: number;
  kindId: number;
}


export interface IPkLocalData {
  brandId: number;
  brandName: string;
  kindId: number;
  kindName: string;
  modelName: string;
  myid: number;
  thumb: string;
  price: string;
  year: number | string;
  isChecked: boolean;
}

export interface ISpecificationParams {
  kindId: string;
  nk: string;
  inStock: string;
  firstModelYearId?: string;
}

export interface IFilterParams {
  driveType: string[]; // 驱动形式
  power: string[]; // 动力形式
  gas: string[]; // 排气量
  diffItems?: string[]; // 高亮不同項、隱藏相同項、隱藏暫無項
}

export interface ITransformedData {
  equipSpec: {
    id: number;
    items: {
      entryId: number;
      id: number;
      important: boolean;
      introId: number;
      isAppend: boolean;
      itemss: any[];
      name: string;
      sort: number;
      type: string;
      unit: string;
      value: string;
      [key: string]: any;
    }[];
    name: string;
    sort: number;
    type: number;
  }[];
  modelYearInfo: IModelYearInfo[];
}


export interface IRecommendData {
  /**
   * 行为推荐列表
   */
  behaviorList: IRecommendList[];
  /**
   * 推荐热门比较车款列表
   */
  list: IRecommendList[];
}

export interface IRecommendList {
  brandId: number;
  brandName: string;
  kindId: number;
  kindName: string;
  modelName: string;
  myid: number;
  price: string;
  thumb: string;
  title: string;
  year: number;
}


export interface IHistoryList {
  brandId?: number;
  brandName?: string;
  driveType?: string;
  gas?: string;
  isInquiry?: number;
  kindId?: number;
  kindName?: string;
  modelName?: string;
  modelYearId?: number;
  myid?: number;
  power?: string;
  price?: number;
  saleStop?: boolean;
  thumb?: string;
  year?: number;
}


